module.exports = __webpack_public_path__ + "img/cake-intro-x1.4d5e6381.png";